export const metamaskClientsRdns = {
    main: 'io.metamask',
    flask: 'io.metamask.flask',
    institutional: 'io.metamask.mmi',
};
// Cache, as when the function is recalled, we can reuse instead of continue waiting
const providerCache = {};
/**
 * This uses EIP6963 to find all metamask accounts and returns the first matching provider
 * the consumer requests (main, flask, institutional, or any)
 *
 * @param type - the MetaMask Wallet type (main, flask, institutional, or any)
 * @returns a ethers provider so you can make requests to that specific wallet
 */
export function getMetaMaskProviderEIP6963(type = 'any') {
    return new Promise((res) => {
        if (type !== 'any' && metamaskClientsRdns[type] === undefined) {
            res(null);
            return;
        }
        const cachedProvider = providerCache[type];
        if (cachedProvider) {
            res(cachedProvider);
            return;
        }
        const providers = [];
        const handleProviderEvent = (event) => {
            const typedEvent = event;
            const providerDetail = typedEvent?.detail;
            if (providerDetail?.provider && providerDetail?.info?.rdns) {
                providers.push({
                    rdns: providerDetail?.info?.rdns,
                    provider: providerDetail?.provider,
                });
            }
        };
        window.addEventListener('eip6963:announceProvider', handleProviderEvent);
        window.dispatchEvent(new Event('eip6963:requestProvider'));
        /**
         * It may take some time for the events to be emitted from the different wallets.
         * So waiting a small period of time before we use the collected events.
         */
        setTimeout(() => {
            // remove attached listener
            window.removeEventListener('eip6963:announceProvider', handleProviderEvent);
            let provider;
            if (type === 'any') {
                // return the first MM client we find
                const metamaskClients = Object.values(metamaskClientsRdns);
                provider =
                    providers.find((p) => metamaskClients.includes(p.rdns))?.provider ??
                        null;
            }
            else {
                const metamaskRdns = metamaskClientsRdns[type];
                provider =
                    providers.find((p) => p.rdns === metamaskRdns)?.provider ?? null;
            }
            if (provider) {
                providerCache[type] = provider;
            }
            return res(provider);
        }, 100);
    });
}
//# sourceMappingURL=eip-6963-metamask-provider.mjs.map